import React from "react";
import { Box, Skeleton, Tab, Tabs } from "@mui/material";
import { a11yProps } from "../constants";

type Props = {
  tabIndex: number;
  applicants: string[];
  isXsOrSm: boolean;
  tabsListLoading: boolean;
  isApplicantTabsLoading: boolean;
  onChange: (_event: React.SyntheticEvent, newValue: number) => void;
};

export function ApplicantTabsNav({
  tabIndex,
  applicants,
  isXsOrSm,
  tabsListLoading,
  isApplicantTabsLoading,
  onChange,
}: Props) {
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        mb: 2,
      }}
    >
      {tabsListLoading ? (
        <Box
          sx={{
            display: "flex",
            gap: 2,
            overflow: "hidden",
            borderBottom: 1,
            borderColor: "divider",
            pb: "2px",
          }}
        >
          {[1, 2, 3].map((item) => (
            <Skeleton
              key={item}
              variant="rectangular"
              width={100}
              height={40}
              sx={{ borderRadius: "8px 8px 0 0" }}
            />
          ))}
        </Box>
      ) : (
        <Tabs
          value={tabIndex}
          onChange={onChange}
          variant={"scrollable"}
          {...(isXsOrSm && {
            scrollButtons: "auto",
            allowScrollButtonsMobile: false,
          })}
          sx={{
            flexGrow: 1,
            minWidth: 0,
            "& .MuiTabs-indicator": { backgroundColor: "#00b3b5" },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              color: "#616161",
              "&.Mui-selected": { color: "#00b3b5" },
            },
          }}
        >
          {isApplicantTabsLoading ? (
            <>
              {Array.from({ length: 4 }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width={120}
                  height={40}
                  sx={{
                    borderRadius: "4px",
                    mx: 0.5,
                  }}
                />
              ))}
            </>
          ) : (
            applicants?.map((a: any, i: any) => (
              <Tab
                key={i}
                label={a === "Applicant" ? "Applicant" : `Co-Applicant ${i}`}
                {...a11yProps(i)}
              />
            ))
          )}
        </Tabs>
      )}
    </Box>
  );
}

